// extracted by mini-css-extract-plugin
export var colorSquare = "_r5-0";
export var danger = "_r5-5";
export var lightPink = "_r5-8";
export var neutralBlue = "_r5-7";
export var neutralYellow = "_r5-6";
export var normal = "_r5-1";
export var primary = "_r5-2";
export var primaryLight = "_r5-3";
export var solidBlack = "_r5-g";
export var solidGreen = "_r5-b";
export var solidLightBlue = "_r5-d";
export var solidNavy = "_r5-c";
export var solidOrange = "_r5-f";
export var solidPink = "_r5-e";
export var solidRed = "_r5-9";
export var solidYellow = "_r5-a";
export var success = "_r5-4";